import type { Category, VideoItem } from "@/types/video";

export const categories: Category[] = [
  {
    id: "entertainment",
    name: "娱乐",
    icon: "ri-film-line",
    description: "综艺名场面、影视剪辑与热门话题，三分钟追完今天的热搜。",
  },
  {
    id: "life",
    name: "生活",
    icon: "ri-home-smile-line",
    description: "日常记录、居家改造与城市观察，把普通日子过出一点意思。",
  },
  {
    id: "funny",
    name: "搞笑",
    icon: "ri-emotion-laugh-line",
    description: "沙雕日常、反转剧情与爆笑名场面，专治各种不开心。",
  },
  {
    id: "music",
    name: "音乐",
    icon: "ri-music-2-line",
    description: "街头翻唱、原创 Demo 与现场片段，用耳朵逛一遍夏天。",
  },
  {
    id: "food",
    name: "美食",
    icon: "ri-restaurant-2-line",
    description: "街头小吃、家常菜谱与探店实录，深夜观看需要自备宵夜。",
  },
  {
    id: "travel",
    name: "旅行",
    icon: "ri-compass-3-line",
    description: "城市漫步、自然风光与实用攻略，先云旅行再出发。",
  },
];

export const videos: VideoItem[] = [
  {
    id: "v001",
    title: "三分钟看懂今年最火的综艺名场面",
    categoryId: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20editorial%20short%20video%20thumbnail%20of%20a%20glowing%20purple%20television%20studio%20stage%20with%20warm%20spotlights%20and%20rounded%20geometric%20props%2C%20bold%20magenta%20and%20orange%20lighting%2C%20clean%20gradient%20backdrop%2C%20cinematic%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=egg-v001-cover&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20modern%20television%20variety%20show%20stage%20bathed%20in%20deep%20eggplant%20purple%20and%20warm%20amber%20spotlights%2C%20glowing%20round%20light%20rings%2C%20soft%20haze%2C%20luxurious%20velvet%20curtains%2C%20artistic%20abstract%20editorial%20photography%2C%20rich%20contrast%2C%20no%20text&width=1600&height=900&seq=egg-hero-01&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
    duration: 134,
    uploadTime: "2026-10-15",
    views: 1286000,
    author: "小茄剪辑室",
    description:
      "把这一季最出圈的综艺片段重新剪在一起：突然的沉默、失控的笑场，还有那句被全网模仿的台词。三分钟补完所有名场面，适合通勤路上快速消化。",
    tags: ["综艺", "名场面", "影视剪辑", "热点"],
    featured: true,
  },
  {
    id: "v002",
    title: "深夜厨房：一碗治愈的番茄鸡蛋面",
    categoryId: "life",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20night%20kitchen%20scene%20with%20a%20steaming%20bowl%20of%20tomato%20egg%20noodles%20on%20a%20warm%20wooden%20table%2C%20soft%20amber%20lamp%20light%2C%20purple%20ceramic%20bowl%2C%20gentle%20steam%2C%20shallow%20depth%20of%20field%2C%20editorial%20food%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=egg-v002-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4",
    duration: 272,
    uploadTime: "2026-10-14",
    views: 864000,
    author: "一颗番茄",
    description:
      "加班回家只剩二十分钟，也能做出一碗热乎的番茄鸡蛋面。从煎蛋的火候到汤汁的浓度，全程实拍不加速，厨房新手可以照着做。",
    tags: ["厨房", "夜宵", "治愈", "家常菜"],
    featured: false,
  },
  {
    id: "v003",
    title: "当代打工人周一早上的真实状态",
    categoryId: "funny",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20comedic%20portrait%20of%20a%20sleepy%20young%20office%20worker%20holding%20a%20giant%20coffee%20cup%20at%20a%20bus%20stop%20in%20soft%20morning%20light%2C%20bright%20orange%20jacket%2C%20muted%20lavender%20city%20background%2C%20expressive%20face%2C%20editorial%20style%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=egg-v003-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
    duration: 88,
    uploadTime: "2026-10-13",
    views: 1562000,
    author: "阿哲不加班",
    description:
      "闹钟响了七次、袜子只剩一只、地铁门在面前关上。每一个镜头都过于真实，看完只想说一句：这不是演的，这是我本人。",
    tags: ["搞笑", "通勤", "反转", "职场"],
    featured: false,
  },
  {
    id: "v004",
    title: "街头翻唱《晚风》一开口全场安静",
    categoryId: "music",
    cover:
      "https://readdy.ai/api/search-image?query=Street%20musician%20singing%20with%20an%20acoustic%20guitar%20at%20dusk%20under%20warm%20string%20lights%2C%20small%20crowd%20silhouettes%2C%20deep%20plum%20evening%20sky%2C%20golden%20bokeh%2C%20intimate%20concert%20atmosphere%2C%20cinematic%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=egg-v004-cover&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=Atmospheric%20night%20street%20performance%20with%20a%20singer%20and%20acoustic%20guitar%20surrounded%20by%20golden%20fairy%20lights%2C%20blurred%20crowd%2C%20deep%20eggplant%20purple%20night%20sky%2C%20warm%20orange%20glow%2C%20artistic%20cinematic%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=egg-hero-04&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
    duration: 185,
    uploadTime: "2026-10-16",
    views: 978000,
    author: "耳朵散步",
    description:
      "周末的旧街口，一把木吉他和一个不太专业的音箱。副歌进来的瞬间，路过的人全部停下脚步。这一版没有修音，只有现场的风声和掌声。",
    tags: ["翻唱", "街头", "治愈", "现场"],
    featured: true,
  },
  {
    id: "v005",
    title: "成都巷子里的锅盔摊，排队一小时也值",
    categoryId: "food",
    cover:
      "https://readdy.ai/api/search-image?query=Golden%20crispy%20Sichuan%20guokui%20flatbread%20being%20lifted%20from%20a%20rustic%20street%20stall%20griddle%2C%20warm%20orange%20charcoal%20glow%2C%20steam%20and%20sesame%20seeds%2C%20blurred%20alley%20background%20with%20lavender%20shadows%2C%20appetizing%20food%20photography%2C%20no%20text&width=800&height=450&seq=egg-v005-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
    duration: 312,
    uploadTime: "2026-10-11",
    views: 452000,
    author: "干饭地图",
    description:
      "藏在老小区门口的小摊，只卖三种口味，下午两点就卖完。我们蹲了两个下午，拍到老板揉面、贴炉、刷酱的全过程，顺便问到了排队最短的时间。",
    tags: ["探店", "成都", "小吃", "街头美食"],
    featured: false,
  },
  {
    id: "v006",
    title: "三天两夜大理：洱海边的慢生活",
    categoryId: "travel",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20lakeside%20morning%20at%20Erhai%20Lake%20with%20a%20wooden%20pier%2C%20soft%20mist%20over%20calm%20water%2C%20distant%20mountains%2C%20pastel%20lavender%20and%20peach%20sunrise%20sky%2C%20minimal%20travel%20editorial%20photography%2C%20tranquil%20atmosphere%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=egg-v006-cover&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=Panoramic%20sunrise%20over%20Erhai%20Lake%20in%20Dali%20with%20soft%20pink%20and%20violet%20clouds%2C%20silhouetted%20mountains%2C%20calm%20reflective%20water%2C%20a%20lone%20wooden%20boat%2C%20dreamy%20travel%20cinematography%2C%20soft%20light%20rays%2C%20no%20text&width=1600&height=900&seq=egg-hero-06&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4",
    duration: 400,
    uploadTime: "2026-10-10",
    views: 612000,
    author: "慢慢走工作室",
    description:
      "不赶景点的一趟大理：住在洱海边的白族院子，骑车去喜洲吃破酥粑粑，傍晚在才村码头等一场日落。附上三天路线、交通和住宿花费清单。",
    tags: ["大理", "洱海", "攻略", "慢旅行"],
    featured: true,
  },
  {
    id: "v007",
    title: "用一百块改造出租屋书桌",
    categoryId: "life",
    cover:
      "https://readdy.ai/api/search-image?query=Before%20and%20after%20style%20cozy%20small%20desk%20setup%20with%20warm%20wood%20desk%20mat%2C%20small%20purple%20desk%20lamp%2C%20plants%20and%20stationery%2C%20soft%20natural%20window%20light%2C%20cream%20wall%2C%20minimal%20interior%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=egg-v007-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4",
    duration: 440,
    uploadTime: "2026-10-09",
    views: 388000,
    author: "小房间计划",
    description:
      "出租屋不能打孔，也不能换家具，那就从桌面开始。一百块预算，买了桌垫、收纳盒、夹灯和一株绿植，顺便分享三个让桌面看起来更贵的摆放技巧。",
    tags: ["家居", "改造", "省钱", "出租屋"],
    featured: false,
  },
  {
    id: "v008",
    title: "综艺史上最尴尬的十秒钟",
    categoryId: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=Two%20variety%20show%20hosts%20standing%20awkwardly%20on%20a%20minimal%20purple%20stage%20with%20an%20empty%20microphone%20stand%2C%20dramatic%20spotlight%2C%20comedic%20tension%2C%20bold%20magenta%20backdrop%2C%20clean%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=egg-v008-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackOnStreetAndDirt.mp4",
    duration: 58,
    uploadTime: "2026-10-08",
    views: 2210000,
    author: "小茄剪辑室",
    description:
      "提问没人接、掌声提前响、嘉宾说错名字。短短十秒，空气都凝固了。反复观看会发现更多细节，建议戴耳机。",
    tags: ["综艺", "尴尬", "爆笑", "名场面"],
    featured: false,
  },
  {
    id: "v009",
    title: "猫咪第一次见到雪的反应",
    categoryId: "funny",
    cover:
      "https://readdy.ai/api/search-image?query=Fluffy%20orange%20cat%20cautiously%20touching%20fresh%20snow%20with%20one%20paw%20on%20a%20sunny%20winter%20balcony%2C%20soft%20white%20snowflakes%2C%20warm%20afternoon%20light%2C%20shallow%20depth%20of%20field%2C%20playful%20pet%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=egg-v009-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4",
    duration: 42,
    uploadTime: "2026-10-07",
    views: 1842000,
    author: "橘座本座",
    description:
      "南方猫生第一次见到雪，从怀疑、试探到疯狂刨雪只用了十五秒。最后那声不满的喵，像是投诉我们没提前通知。",
    tags: ["萌宠", "猫咪", "搞笑", "冬天"],
    featured: false,
  },
  {
    id: "v010",
    title: "凌晨四点的城市，他们在做什么",
    categoryId: "life",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20dawn%20city%20street%20scene%20with%20a%20lone%20street%20sweeper%20and%20glowing%20shop%20windows%2C%20deep%20violet%20blue%20hour%20sky%2C%20warm%20amber%20lamps%2C%20wet%20pavement%20reflections%2C%20documentary%20photography%2C%20moody%20atmosphere%2C%20no%20text&width=800&height=450&seq=egg-v010-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/VolkswagenGTIReview.mp4",
    duration: 495,
    uploadTime: "2026-10-06",
    views: 297000,
    author: "城市夜行",
    description:
      "跟着环卫工、早餐摊主和代驾司机，走过城市最安静的四小时。没有旁白，只有环境声和几句闲聊，记录那些我们睡着时仍在运转的生活。",
    tags: ["纪实", "城市", "深夜", "人物"],
    featured: false,
  },
  {
    id: "v011",
    title: "十级手速挑战：一秒八个动作",
    categoryId: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20fast%20moving%20hands%20performing%20a%20rhythm%20challenge%20under%20dramatic%20purple%20and%20orange%20stage%20lighting%2C%20motion%20blur%2C%20dark%20studio%20background%2C%20high%20energy%20editorial%20photography%2C%20vivid%20contrast%2C%20no%20text&width=800&height=450&seq=egg-v011-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4",
    duration: 105,
    uploadTime: "2026-10-05",
    views: 733000,
    author: "挑战研究所",
    description:
      "从一秒两个动作练到一秒八个，我们记录了整整两周的翻车过程。慢镜头回放那一刻，手指真的出现了残影。",
    tags: ["挑战", "手速", "综艺", "慢镜头"],
    featured: false,
  },
  {
    id: "v012",
    title: "原创民谣《茄子色的夏天》Demo",
    categoryId: "music",
    cover:
      "https://readdy.ai/api/search-image?query=Sunlit%20bedroom%20music%20corner%20with%20an%20acoustic%20guitar%20leaning%20against%20a%20lavender%20wall%2C%20handwritten%20lyrics%20on%20a%20notebook%2C%20warm%20afternoon%20light%20and%20soft%20shadows%2C%20intimate%20indie%20music%20editorial%20photo%2C%20no%20text&width=800&height=450&seq=egg-v012-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
    duration: 248,
    uploadTime: "2026-10-04",
    views: 341000,
    author: "林间回声",
    description:
      "写给一个总是错过末班车的夏天。吉他和人声都是一遍过，保留了换气声和小小的走音，可能不够完美，但很像那个季节。",
    tags: ["原创", "民谣", "Demo", "夏天"],
    featured: false,
  },
  {
    id: "v013",
    title: "广州早茶攻略：本地人早餐清单",
    categoryId: "food",
    cover:
      "https://readdy.ai/api/search-image?query=Traditional%20Cantonese%20dim%20sum%20table%20with%20steamed%20shrimp%20dumplings%2C%20rice%20rolls%20and%20tea%20in%20a%20bright%20old%20teahouse%2C%20warm%20wooden%20furniture%2C%20soft%20morning%20window%20light%2C%20appetizing%20editorial%20food%20photography%2C%20no%20text&width=800&height=450&seq=egg-v013-cover&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=Abundant%20Cantonese%20dim%20sum%20spread%20on%20a%20round%20table%20with%20bamboo%20steamers%2C%20tea%20pots%20and%20delicate%20pastries%2C%20warm%20golden%20morning%20light%2C%20rich%20orange%20and%20plum%20tones%2C%20editorial%20food%20photography%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=egg-hero-13&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
    duration: 542,
    uploadTime: "2026-10-03",
    views: 518000,
    author: "干饭地图",
    description:
      "早上七点的老茶楼，推车还没出来就已经坐满。跟着本地阿姨点了一桌：虾饺、干蒸、肠粉、艇仔粥，最后结账人均不到五十。附上点单顺序和避坑提示。",
    tags: ["广州", "早茶", "攻略", "探店"],
    featured: true,
  },
  {
    id: "v014",
    title: "青海湖环线自驾，途经三种天气",
    categoryId: "travel",
    cover:
      "https://readdy.ai/api/search-image?query=Open%20road%20driving%20along%20Qinghai%20Lake%20with%20yellow%20rapeseed%20fields%2C%20dramatic%20clouds%20and%20sunlight%20breaking%20through%2C%20distant%20snow%20mountains%2C%20deep%20violet%20sky%20tones%2C%20cinematic%20travel%20photography%2C%20no%20text&width=800&height=450&seq=egg-v014-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4",
    duration: 690,
    uploadTime: "2026-10-02",
    views: 289000,
    author: "在路上电台",
    description:
      "一天之内经历晴天、冰雹和日落。环湖三天，走了大约七百公里，把路况、加油点、住宿和拍照机位都整理在视频最后。",
    tags: ["青海湖", "自驾", "攻略", "公路"],
    featured: false,
  },
  {
    id: "v015",
    title: "模仿老板开会的九个经典句式",
    categoryId: "funny",
    cover:
      "https://readdy.ai/api/search-image?query=Comedic%20office%20meeting%20scene%20with%20a%20young%20person%20impersonating%20a%20boss%20in%20front%20of%20a%20whiteboard%2C%20glass%20conference%20room%2C%20warm%20orange%20accent%20chair%2C%20soft%20purple%20wall%2C%20playful%20editorial%20portrait%2C%20no%20text&width=800&height=450&seq=egg-v015-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
    duration: 156,
    uploadTime: "2026-10-01",
    views: 1210000,
    author: "阿哲不加班",
    description:
      "\"我们先对齐一下颗粒度\"\"这个需求很简单\"\"时间还来得及\"。九句话，每一句都能让会议室安静三秒。建议不要在团建时播放。",
    tags: ["搞笑", "职场", "模仿", "开会"],
    featured: false,
  },
  {
    id: "v016",
    title: "把旧牛仔裤改成托特包",
    categoryId: "life",
    cover:
      "https://readdy.ai/api/search-image?query=Handmade%20denim%20tote%20bag%20on%20a%20wooden%20craft%20table%20with%20scissors%2C%20thread%20and%20fabric%20scraps%2C%20warm%20daylight%20from%20a%20window%2C%20soft%20purple%20linen%20curtain%2C%20slow%20craft%20editorial%20photography%2C%20no%20text&width=800&height=450&seq=egg-v016-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
    duration: 238,
    uploadTime: "2026-09-29",
    views: 264000,
    author: "小房间计划",
    description:
      "一条穿旧的牛仔裤，剪两刀、缝四道线，变成一个能装电脑的托特包。全程手缝版本，没有缝纫机也能跟着做。",
    tags: ["手工", "改造", "环保", "旧物"],
    featured: false,
  },
  {
    id: "v017",
    title: "音乐节后台：乐手们上台前在干嘛",
    categoryId: "music",
    cover:
      "https://readdy.ai/api/search-image?query=Backstage%20music%20festival%20scene%20with%20a%20guitarist%20tuning%20under%20warm%20string%20lights%2C%20flight%20cases%20and%20cables%2C%20deep%20plum%20shadows%2C%20golden%20rim%20light%2C%20candid%20documentary%20photography%2C%20energetic%20atmosphere%2C%20no%20text&width=800&height=450&seq=egg-v017-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
    duration: 344,
    uploadTime: "2026-09-27",
    views: 208000,
    author: "耳朵散步",
    description:
      "调音、吃香蕉、原地转圈、对着镜子说加油。上台前二十分钟的后台，比舞台更真实。这一期没有采访提纲，就是跟着他们走来走去。",
    tags: ["音乐节", "后台", "现场", "纪录片"],
    featured: false,
  },
  {
    id: "v018",
    title: "演技派新人挑战一分钟哭戏",
    categoryId: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20dramatic%20portrait%20of%20a%20young%20actor%20with%20teary%20eyes%20under%20a%20single%20soft%20spotlight%20in%20a%20dark%20purple%20studio%2C%20emotional%20cinematic%20lighting%2C%20film%20grain%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=450&seq=egg-v018-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4",
    duration: 72,
    uploadTime: "2026-09-25",
    views: 947000,
    author: "镜头前的一分钟",
    description:
      "没有眼药水，没有背景音乐，只有一句台词和一分钟倒计时。从深呼吸到眼泪落下来，用了四十七秒。",
    tags: ["演技", "挑战", "哭戏", "新人"],
    featured: false,
  },
  {
    id: "v019",
    title: "西安回民街的十种碳水快乐",
    categoryId: "food",
    cover:
      "https://readdy.ai/api/search-image?query=Bustling%20Xi%20an%20food%20street%20at%20dusk%20with%20steaming%20buns%2C%20skewers%20and%20hand%20pulled%20noodles%2C%20warm%20orange%20lantern%20glow%2C%20crowd%20in%20soft%20focus%2C%20rich%20appetizing%20street%20food%20photography%2C%20no%20text&width=800&height=450&seq=egg-v019-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4",
    duration: 446,
    uploadTime: "2026-09-23",
    views: 376000,
    author: "干饭地图",
    description:
      "肉夹馍、甑糕、柿子饼、油泼面……一条街吃下来，碳水摄入直接超标。视频里标了每一家的位置和排队时间，按顺序吃不会撑太早。",
    tags: ["西安", "碳水", "小吃", "探店"],
    featured: false,
  },
  {
    id: "v020",
    title: "周末去海边看一场日落",
    categoryId: "travel",
    cover:
      "https://readdy.ai/api/search-image?query=Peaceful%20beach%20sunset%20with%20gentle%20waves%20and%20two%20silhouettes%20walking%20along%20the%20shore%2C%20peach%20and%20lavender%20sky%2C%20soft%20golden%20reflections%20on%20wet%20sand%2C%20minimal%20travel%20cinematography%2C%20warm%20calm%20mood%2C%20no%20text&width=800&height=450&seq=egg-v020-cover&orientation=landscape",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackOnStreetAndDirt.mp4",
    duration: 172,
    uploadTime: "2026-09-20",
    views: 423000,
    author: "慢慢走工作室",
    description:
      "没有攻略，没有打卡点，就是坐两个小时的车去看一场日落。海浪声保留原样，适合下班后戴着耳机放空。",
    tags: ["海边", "日落", "周末", "治愈"],
    featured: false,
  },
];